/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ url: NonNullable<unknown> }} Err_Tournament_External_RegistrationInputs */



/**
* | output |
* | --- |
* | "Registration for this tournament is handled at {url}" |
*
* @param {Err_Tournament_External_RegistrationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_external_registration = /** @type {((inputs: Err_Tournament_External_RegistrationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_External_RegistrationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Les inscriptions à ce tournoi se font sur ${i?.url}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Las inscripciones a este torneo se gestionan en ${i?.url}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`As inscrições para este torneio são feitas em ${i?.url}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Le iscrizioni a questo torneo si gestiscono su ${i?.url}`)
	return /** @type {LocalizedString} */ (`Registration for this tournament is handled at ${i?.url}`)
});